import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/app/(normalRender)/pricing/PlanCtaTelemetry.tsx");
